import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 300);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.button
                    type="button"
                    aria-label="Back to top"
                    onClick={scrollTop}
                    data-testid="back-to-top-btn"
                    initial={{ opacity: 0, y: 20, scale: 0.85 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 20, scale: 0.85 }}
                    transition={{ duration: 0.25 }}
                    className="fixed bottom-24 right-6 z-40 w-12 h-12 rounded-full bg-gold text-black hover:bg-[#C5A030] hover:scale-110 active:scale-95 shadow-[0_8px_30px_rgba(212,175,55,0.35)] flex items-center justify-center transition-transform"
                >
                    <ArrowUp size={20} strokeWidth={2.4} />
                </motion.button>
            )}
        </AnimatePresence>
    );
};

export default BackToTop;
